import { render, staticRenderFns } from "./Cookiebar.vue?vue&type=template&id=07a7d3a2"
import script from "./Cookiebar.vue?vue&type=script&lang=js"
export * from "./Cookiebar.vue?vue&type=script&lang=js"
import style0 from "./Cookiebar.vue?vue&type=style&index=0&id=07a7d3a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports